<template>
    <div class="home"
      v-on:scroll="onScroll"
      :class="[
        inapp ? 'inapp' : '',
        !scrolled ? '-scrolled': '',
        opennav ? 'open': ''
      ]"
    >
        <Nav :scrollcount.sync="scrollval" v-on:childToParent="onChildClick"></Nav>
        <div class="docs docs__container" :class="opennav ? 'open': ''">
            <p class="docs__title">Healthcare Customers’ Privacy Policy</p>
            <div class="docs docs__policy" v-html="policy">

            </div>
        </div>
        <FooterHome></FooterHome>
    </div>
</template>
<script>
import axios from 'axios';
import Nav from '../../components/Nav.vue';
import FooterHome from '../../components/FooterHome.vue';

export default {
  data() {
    return {
      scrollval: 0,
      inapp: false,
      contact: process.env.VUE_APP_CONTACT_EMAIL,
      vigosemail: process.env.VUE_APP_CONTACT_VIGOS,
      opennav: false,
      policy: '',
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.inapp = true;
    }
    axios.get('/files/policy.html').then((response) => {
      let stringified = JSON.stringify(response.data);
      stringified = stringified.replace(/%CONTACT%/g, this.contact);
      stringified = stringified.replace(/%CONTACTVIGOS%/g, this.vigosemail);
      this.policy = JSON.parse(stringified);
    });
  },
  components: {
    Nav,
    FooterHome,
  },
  methods: {
    onChildClick(value) {
      this.opennav = value;
    },
    onScroll() {
      const el = document.querySelector('div.home');
      this.scrollval = el.scrollTop;

      this.scrolled = true;
      if (el.scrollTop !== 0) {
        this.scrolled = false;
      }
    },
  },
};
</script>
